const Menu = [
    {
        id: 1,
        category:"Movies",
        image:"img/poster/ucm_poster01.jpg",
        title:"Women's Day",
        date:"2022",
        quality:"hd",
        duration:"128 min",
        ratings:"3.5",
       
    },
    {
        id: 2,
        category:"Movies",
        image:"img/poster/ucm_poster02.jpg",
        title:"The Perfect Match",
        date:"2022",
        quality:"2k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 3,
        category:"Movies",
        image:"img/poster/ucm_poster03.jpg",
        title:"The Dog Woof",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 4,
        category:"Movies",
        image:"img/poster/ucm_poster04.jpg",
        title:"The Easy Reach",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 5,
        category:"Animation",
        image:"img/poster/ucm_poster05.jpg",
        title:"The Cooking",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 6,
        category:"Animation",
        image:"img/poster/ucm_poster06.jpg",
        title:"The Hikaru",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 7,
        category:"Animation",
        image:"img/poster/ucm_poster07.jpg",
        title:"Life Quotes",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 8,
        category:"Animation",
        image:"img/poster/ucm_poster08.jpg",
        title:"The Beachball",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 9,
        category:"Anime",
        image:"img/poster/ucm_poster03.jpg",
        title:"The Dog Woof",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 10,
        category:"Anime",
        image:"img/poster/ucm_poster02.jpg",
        title:"The Perfect Match",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 11,
        category:"Anime",
        image:"img/poster/ucm_poster01.jpg",
        title:"Women's Day",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    {
        id: 12,
        category:"Anime",
        image:"img/poster/ucm_poster03.jpg",
        title:"The Dog Woof",
        date:"2021",
        quality:"4k",
        duration:"128 min",
        ratings:"3.5",
    },
    
    
    
    
    
] 
export default Menu;